import React, { useEffect, useState } from 'react';
import { loadImage } from '../../../../mainv3/containers/trial6/state/TrialResourceState';
import { animated, useSpring } from 'react-spring';

type Props = {
    src: string;
    alt?: string;
    offset?: number;
    onEnter?: () => any;
    onClick?: () => any;
    onLoadCompleted?: () => any;
    className?: string;
    styleName?: string;
};

/**
 * Lazy load image when the image intersected with the viewport
 * NOTE: this is experimental and not thoroughly tested
 */
export const LazyImage = (props: Props) => {
    const { src, offset = 0, alt, onEnter, onLoadCompleted, className, onClick } = props;
    const [ref, setRef] = useState(null);
    const [entered, setEntered] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const styleProps = useSpring({ opacity: loaded ? 1 : 0 });
    useEffect(
        () => {
            // Reset internal states when the src changed
            setEntered(false);
            setLoaded(false);
        },
        [src]
    );
    useEffect(
        () => {
            if (!ref) {
                return;
            }
            const observer = new IntersectionObserver(
                async ([entry]) => {
                    if (entry.isIntersecting && !entered) {
                        setEntered(true);
                        onEnter && onEnter();
                        await loadImage(src);
                        setLoaded(true);
                        onLoadCompleted && onLoadCompleted();
                    }
                },
                {
                    rootMargin: `0px 0px ${offset}px 0px`,
                }
            );
            observer.observe(ref);
            return () => observer.disconnect();
        },
        [ref, entered]
    );
    return (
        <animated.img
            style={styleProps}
            alt={alt}
            className={className}
            ref={setRef}
            src={loaded ? src : null}
            onClick={onClick}
        />
    );
};
